import { Component, inject, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { provideIcons } from '@ng-icons/core';
import { lucideLink2 } from '@ng-icons/lucide';
import { BrnDialogRef, injectBrnDialogContext } from '@spartan-ng/brain/dialog';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmDialogImports } from '@spartan-ng/helm/dialog';
import { HlmIconImports } from '@spartan-ng/helm/icon';
import { HlmInputImports } from '@spartan-ng/helm/input';
import { HlmSeparatorImports } from '@spartan-ng/helm/separator';

import { AlerteComponent } from '../../alerte/alerte.component';

@Component({
  selector: 'app-dialog-confirm-delete',
  imports: [
    HlmDialogImports,
    HlmButtonImports,
    HlmIconImports,
    HlmSeparatorImports,
    AlerteComponent,
    FormsModule,
    HlmInputImports,
  ],
  templateUrl: './dialog-confirm-delete.component.html',
  providers: [provideIcons({ lucideLink2 })],
})
export class DialogConfirmDeleteComponent {
  readonly #dialogRef = inject<BrnDialogRef<boolean>>(BrnDialogRef);
  readonly #dialogContext = injectBrnDialogContext<{
    nom: string;
    parentText?: string;
    childrenText: string;
    typeElement: string;
  }>();

  readonly CONFIRMATION_SUPPRESSION_TEXTE = 'SUPPRIMER';

  readonly nom = this.#dialogContext.nom;
  readonly parentText = this.#dialogContext.parentText;
  readonly childrenText = this.#dialogContext.childrenText;
  readonly typeElement = this.#dialogContext.typeElement;

  supprimer = model('');

  public close() {
    if (this.supprimer() === this.CONFIRMATION_SUPPRESSION_TEXTE) {
      this.#dialogRef.close(true);
    }
  }
}
